// extracted by mini-css-extract-plugin
export default {"msg_container":"Yfa","message":"Zfa","show":"aga","fromRD":"bga","fromCustomer":"cga","note":"ega","loading":"fga","image":"gga","initials":"hga","input_wrapper":"iga","input":"jga"};
    if(module.hot) {
      // 1721922369203
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  